import vnFlag from '../asset/img/vietnamese.png';
import enFlag from '../asset/img/english.png';
import jpFlag from '../asset/img/japanese.webp';

export const LANGUAGES = [
    { className: 'enFlag', flag: enFlag, label: 'English', code: 'en' },
    { className: 'vnFlag', flag: vnFlag, label: 'Tiếng việt ', code: 'vi' },
    { className: 'jpFlag', flag: jpFlag, label: '日本語 ', code: 'jp' },
];
